<div class="row">
  <div class="col-md-12">
    <cap-content-header [disableBreadcrumb]="true">
      <cap-title>
        {{ "configuration.konfigurationVerwalten" | translate }}
      </cap-title>
    </cap-content-header>
    <cap-rubrik [isClosable]="false" [isOpen]="true" id="download">
      <ng-container class="mt-2" title>
        <h3>{{ "configuration.konfigurationHerunterladen" | translate }}</h3>
      </ng-container>
      <button (click)="downloadConfiguration()" class="btn btn-primary mt-2" type="button">
        {{ "configuration.download" | translate }}
      </button>
    </cap-rubrik>

    <cap-rubrik [isClosable]="false" [isOpen]="true" id="upload">
      <ng-container class="mt-2" title>
        <h3 class="mb-0 mt-2">{{ "configuration.konfigurationHeraufladen" | translate }}</h3>
      </ng-container>
      <div class="mt-2">
        <div
          (fileOver)="fileOverBase($event)"
          [ngClass]="{ 'nv-file-over': hasBaseDropZoneOver }"
          [uploader]="uploader"
          class="well my-drop-zone"
          ng2FileDrop
          style="height: 250px; width: 250px">
          <span>{{ "configuration.dropZone" | translate }}</span>
        </div>

        <div class="input-group custom-file-button mb-3 mt-1">
          <input [uploader]="uploader" class="form-control" id="inputGroupFile03" ng2FileSelect type="file" />
          <label class="input-group-text" for="inputGroupFile03">{{ "configuration.fileAuswaehlen" | translate }}</label>
        </div>
      </div>

      <div class="mt-2" style="margin-bottom: 40px">
        <h3>{{ "configuration.uploadQueue" | translate }}</h3>
        <p>
          <span>{{ "configuration.queueLength" | translate }}</span
          >:
          {{ uploader?.queue?.length }}
        </p>

        <table class="table">
          <thead>
            <tr>
              <th width="50%">{{ "configuration.name" | translate }}</th>
              <th>{{ "configuration.size" | translate }}</th>
              <th>{{ "configuration.progress" | translate }}</th>
              <th>{{ "configuration.status" | translate }}</th>
              <th>{{ "configuration.actions" | translate }}</th>
            </tr>
          </thead>
          <tbody>
            @for (item of uploader.queue; track item) {
              <tr>
                <td>
                  <strong>{{ item?.file?.name }}</strong>
                </td>
                @if (uploader.isHTML5) {
                  <td nowrap>{{ item?.file?.size / 1024 / 1024 | number: ".2" }} MB</td>
                }
                @if (uploader.isHTML5) {
                  <td>
                    <div class="progress" style="margin-bottom: 0">
                      <div [ngStyle]="{ width: item.progress + '%' }" class="progress-bar" role="progressbar"></div>
                    </div>
                  </td>
                }
                <td class="text-center">
                  @if (item.isSuccess) {
                    <span><i class="glyphicon glyphicon-ok"></i></span>
                  }
                  @if (item.isCancel) {
                    <span><i class="glyphicon glyphicon-ban-circle"></i></span>
                  }
                  @if (item.isError) {
                    <span><i class="glyphicon glyphicon-remove"></i></span>
                  }
                </td>
                <td nowrap>
                  <button (click)="item.cancel()" [disabled]="!item.isUploading" class="btn btn-outline-primary btn-xs me-2" type="button">
                    <span class="glyphicon glyphicon-ban-circle"></span>
                    {{ "configuration.cancel" | translate }}
                  </button>
                  <button (click)="item.remove()" class="btn btn-outline-primary btn-xs me-2" type="button">
                    <span class="glyphicon glyphicon-trash"></span>
                    {{ "configuration.remove" | translate }}
                  </button>
                  <button
                    (click)="item.upload()"
                    [disabled]="item.isReady || item.isUploading || item.isSuccess"
                    class="btn btn-primary btn-xs"
                    type="button">
                    <span class="glyphicon glyphicon-upload"></span>
                    {{ "configuration.upload" | translate }}
                  </button>
                </td>
              </tr>
            }
          </tbody>
        </table>
      </div>
    </cap-rubrik>
  </div>
</div>
